<template>
  <div id="app">
    <nav-bar/>
    <router-view/>
    <transition v-if="showModal" name="modal">
      <div class="modal-mask">
        <div class="modal-wrapper">
          <div class="modal-container">

            <!-- <div class="modal-header">
              <slot name="header">
                default header
              </slot>
            </div> -->

            <div class="modal-body">
              <slot name="body">
                <p>
                  Todo el contenido de este Sitio está protegido por la Ley Federal del Derecho de Autor y/o la Ley de la Propiedad Industrial y su titularidad corresponde a Aleatica, S.A.B. de C.V., sus afiliadas  y/o  subsidiarias  (el  “Contenido”).  Por  lo  tanto,  queda  prohibido  reproducir, publicar, distribuir o permitir el acceso del público a través de cualquier medio, editar,  transformar  y/o  modificar  el  Contenido,  ya  sea  total  o  parcialmente  sin autorización previa y por escrito por parte de Aleatica, S.A.B. de C.V.
                </p>
                <p>
                  El Contenido se proporciona de manera voluntaria, sin tener obligación legal alguna para ello, con la única finalidad de asistir en la comprensión de acontecimientos, hechos y documentos  legales  que  pueden  ser  muy  complejos  y  sujetos  a  interpretación.  En ningún momento podrá considerarse la información contenida en este Sitio como una interpretación jurídicamente vinculante    de    dichos   acontecimientos,    hechos    y documentos. La transcripción de cualquier documento legal deberá de ser interpretada en conjunto con el documento completo al que corresponda. Remitimos al lector a los enlaces correspondientes y documentos originales para una interpretación más completa e integral del Contenido.
                </p>
              </slot>
            </div>

            <div class="modal-footer d-flex- justify-content-center">
                <button class="modal-default-button" @click="showModal = !showModal">
                  Aceptar
                </button>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <footer/>
  </div>
</template>
<script>
import NavBar from './components/home/header'
import Footer from './components/home/footer'

export default {
  name: 'App',
  components: {
    NavBar,
    Footer
  },
  data() {
    return{
      showModal: true
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/App.vue